import React from 'react'
import { Link } from "react-scroll";

function EventButtons() {
  return (
    <div className="w-full h-14  grid grid-cols-6 text-white text-outfit text-xs md:text-md  xl:text-2xl fixed bottom-0">
      <button className=" bg-[#CCCCCC] flex justify-center items-center font-bold hover:font-black duration-150">
        <Link to="music">MUSIC</Link>
      </button>
      <button className=" bg-[#B3B3B3] flex justify-center items-center font-bold hover:font-black duration-150">
        <Link to="dance">DANCE</Link>
      </button>
      <button className=" bg-[#999999] flex justify-center items-center font-bold hover:font-black duration-150">
        <Link to="poetry">POETRY</Link>
      </button>
      <button className=" bg-[#808080] flex justify-center items-center font-bold hover:font-black duration-150">
        <Link to="comedy">COMEDY</Link>
      </button>
      <button className=" bg-[#666666] hidden md:flex  justify-center items-center font-bold hover:font-black duration-150">
        <Link to="empowerment">EMPOWERMENT</Link>
      </button>
      <button className=" bg-[#4D4D4D] hidden md:flex justify-center items-center font-bold hover:font-black duration-150">
        <Link to="photography">PHOTOGRAPHY</Link>
      </button>
      <button className=" bg-[#CECECE] flex md:hidden justify-center items-center font-bold hover:font-black duration-150">
        <Link to="empowerment">EPOWER</Link>
      </button>
      <button className=" bg-[#696969] flex md:hidden  justify-center items-center font-bold hover:font-black duration-150">
        <Link to="photography">PHOTO</Link>
      </button>
    </div>
  );
}

export default EventButtons


     